import React from 'react';
import { useIntl } from 'react-intl';
import * as CON from '../../../common/constants';

interface IReceiverPDFGuideProps {
    selectedBrand: string;
}

export default function ReceiverPDFGuide({
    selectedBrand,
}: IReceiverPDFGuideProps) {
    const intl = useIntl();
    return (
        <div className="receiver-pdf-link">
            <i className="fad fa-file-pdf" />{' '}
            <a
                href={
                    selectedBrand === CON.AUDIBEL
                        ? 'https://cdn.mediavalet.com/usil/starkeyhearingtech/gSbbE1KBukqQ4mnboUipCw/83t1FsosUUqK0ewyKn-omA/Original/Intrigue%20Matrix%20Graphics.pdf'
                        : 'https://cdn.mediavalet.com/usil/starkeyhearingtech/5JDgH6wAu0m6TcVhJfcmVg/sLqSOGVduEelk9eFVLAljQ/Original/Genesis%20Matrix%20Graphics.pdf'
                }
                target="_blank"
            >
                {intl.formatMessage({
                    id: 'PDP_Receiver_Guide',
                    defaultMessage: 'Receiver Guide',
                })}
            </a>
        </div>
    );
}
